import { getDatabase, ref, onValue } from "firebase/database";

export const listenForVersionChange = () => {
  const db = getDatabase();
  const versionRef = ref(db, "config/siteVersion");

  onValue(versionRef, (snapshot) => {
    const newVersion = snapshot.val();
    if (!newVersion) return;

    const currentVersion = localStorage.getItem("siteVersion");

    if (currentVersion && currentVersion !== newVersion) {
      window.location.reload();
    }

    localStorage.setItem("siteVersion", newVersion);
  });
};
